export const setNavbar = {
  methods: {
    setNavbar(visible) {
      this.$store.dispatch("SET_NAVBAR_VISIBLE", visible);
    },
  },
};
